import Windowsticker from './windowsticker';
import StickerPart from './sticker-part';
import { PriceLine } from '../../price-line';
import { CollectionHelper } from 'src/app/helpers/collection-helper';

export default class CustomWindowsticker extends Windowsticker {
  stickerParts?: StickerPart[];
  windowFrame?: boolean;
  windowFrameWidth?: number;
  stickOverWindowFrame?: boolean;
  placementPrice?: number;
  productionPrice?: number;
  prices?: PriceLine[];

  constructor() {
    super();
    this.type = 'CustomWindowSticker';
    this.prices = [];
  }

  // Override
  public canSubmitAsClient(): boolean {
    return (
      CollectionHelper.isPopulated(this.stickerParts) &&
      this.stickerParts.every((sp) => sp.canSubmitAsClient())
    );
  }
}
